import React from 'react';
import { morphism } from 'morphism';
import { schemaDatoButton } from '../../morphismSchema/schemaDatoButton';
import { ButtonTracking } from '@payfit/growth-platform-brand-system-v2/utils/tracking/ButtonTracking';
import { ButtonV2, classNames } from '@payfit/growth-platform-brand-system-v2';

export const ButtonsMobile = ({ mobileButtons, locale }: any) => {
  return (
    <ul className="flex flex-wrap xl:hidden w-full gap-y-16 gap-x-12 mb-[340px] xl:mb-0">
      {mobileButtons &&
        mobileButtons.map((btn: any, key: number) => {
          const cta = morphism(schemaDatoButton, {
            ...btn,
            className: 'transition-all duration-500 w-full block',
            locale,
          });
          return (
            <li
              key={key}
              className={classNames('w-full md:w-[calc(50%-12px/2)]')}
            >
              <ButtonTracking
                component={ButtonV2}
                section={'header_mobileButton'}
                index={key}
                {...cta}
                labelTracking={cta.title}
              />
            </li>
          );
        })}
    </ul>
  );
};
